<script>
    import { fade, fly } from 'svelte/transition';
    import {cookieShowImageData} from "./slideShowStores";

    import { Link } from "svelte-navigator";
    import {operationStore, query} from "@urql/svelte";

    function overlay_click(e) {
        if (!('dontclose' in e.target.dataset))
            open = false;
    }

    export let open = false;
    export let slideshowImages = [];
    export let currentSlideshowImageID = null;
    export let currentSlideshowImage = {};
    let firstOpen = true;

    const getAirshowToImage = operationStore(`
      query ($currentSlideshowImageID: [QueryArgument]) {
        airshowToImage: entry(section: "airshows", status: "live", relatedToAssets: {id: $currentSlideshowImageID}) {
          title
          slug
        }
      }`,);
    $: getAirshowToImage.variables = {
        currentSlideshowImageID
    };

    $: if (open) {
        if(firstOpen) {
            query($getAirshowToImage);
            firstOpen = false;
        }
        currentSlideshowImageIndex = slideshowImages.indexOf(currentSlideshowImage);
    }
    let currentSlideshowImageIndex;
    function previmage() {
        currentSlideshowImageIndex = currentSlideshowImage = (slideshowImages.indexOf(currentSlideshowImage) - 1) >= 0 ? slideshowImages.indexOf(currentSlideshowImage) - 1 : 0;
        currentSlideshowImage = slideshowImages[currentSlideshowImageIndex];
        currentSlideshowImageID = currentSlideshowImage.id;
        console.log('huuuu')
    }
    function nextimage() {
        currentSlideshowImageIndex = (slideshowImages.indexOf(currentSlideshowImage) + 1) < slideshowImages.length ? slideshowImages.indexOf(currentSlideshowImage) + 1 : slideshowImages.length - 1;
        currentSlideshowImage = slideshowImages[currentSlideshowImageIndex];
        currentSlideshowImageID = currentSlideshowImage.id;
    }
    function closeSlideshow() {
        open = false;
    }
    function showImageData() {
        if($cookieShowImageData === '') {
            $cookieShowImageData = 'show';
        } else {
            $cookieShowImageData = '';
        }
    }
    let imageDataElement;
    let imageElement;

    function linkPageReload() {
        console.log(this)
    }

</script>
{#if open}
    <div class="modal-overlay" on:click={overlay_click} on:keydown={overlay_click} transition:fade={{duration: 150}}>
        {#if currentSlideshowImageIndex !== 0}
            <div data-dontclose class="slideshow-nav prev-image" on:click={previmage} on:keydown={previmage}>
                <div data-dontclose class="arrow left">
                    <div data-dontclose class="arrow-top"></div>
                    <div data-dontclose class="arrow-bottom"></div>
                </div>
            </div>
        {/if}
        {#if currentSlideshowImageIndex !== slideshowImages.length-1}
            <div data-dontclose class="slideshow-nav next-image" on:click={nextimage} on:keydown={nextimage}>
                <div class="arrow right" data-dontclose>
                    <div class="arrow-top" data-dontclose></div>
                    <div class="arrow-bottom" data-dontclose></div>
                </div>
            </div>
        {/if}
        <div class="slideshow-nav close-slideshow" on:click={closeSlideshow} on:keydown={closeSlideshow}>
            <div class="line-one"></div>
            <div class="line-two"></div>
        </div>
        <div data-dontclose class="slideshow-nav show-image-data" on:click={showImageData} on:keydown={showImageData} class:active={($cookieShowImageData === 'show')}>
            i
        </div>
        <div class="modal-container">
            <img src="{currentSlideshowImage.detailViewUrl}" data-dontclose bind:this={imageElement} on:click="{showImageData}" on:keydown="{showImageData}">
            <div in:fly={{y:100}}  out:fly={{y:100}} class="image-data" bind:this={imageDataElement} class:closed={($cookieShowImageData !== 'show')}>
                <div class="category info">
                    <h3 data-dontclose>Kategorie</h3>
                    {#each currentSlideshowImage.airplaneCategories as airplaneCategory}
                        <Link class="link-btn" data-dontclose to="/galleries?categories={airplaneCategory.category.id}" on:click={window.location.assign("/galleries?categories="+airplaneCategory.category.id)}>{airplaneCategory.category.title}</Link>
                    {/each}
                    <h3 data-dontclose>Flugzeugtyp / Formation</h3>

                    {#each currentSlideshowImage.airplaneCategories as airplaneCategory}
                        <Link class="link-btn" data-dontclose to="/galleries/?airplaneCategories={airplaneCategory.id}" on:click={window.location.assign("/galleries?airplaneCategories="+airplaneCategory.id)}>{airplaneCategory.title}</Link>
                    {/each}
                </div>
                <div class="plane info">
                    {#if currentSlideshowImage.countries.length > 0}
                        <h3 data-dontclose>Land</h3>
                        {#each currentSlideshowImage.countries as country}
                            <Link class="link-btn" data-dontclose to="/galleries?countries={country.id}" on:click={window.location.assign("/galleries?countries="+country.id)}>{country.title}</Link>
                        {/each}
                    {/if}
                    {#if currentSlideshowImage.registrations.length > 0}
                        <h3 data-dontclose>Immatrikulation</h3>
                        {#each currentSlideshowImage.registrations as registration}
                            <Link class="link-btn" data-dontclose to="/galleries?registrations={registration.id}" on:click={window.location.assign("/galleries?registrations="+registration.id)}>{registration.title}</Link>
                        {/each}
                    {/if}
                    {#if currentSlideshowImage.airlineOperators.length > 0}
                        <h3 data-dontclose>Airline / Operator</h3>
                        {#each currentSlideshowImage.airlineOperators as airlineOperator}
                            <Link class="link-btn" data-dontclose to="/galleries?airlineOperator={airlineOperator.id}" on:click={window.location.assign("/galleries?airlineOperator="+airlineOperator.id)}>{airlineOperator.title}</Link>
                        {/each}
                    {/if}
                    {#if currentSlideshowImage.military === 1}
                        <h3 data-dontclose>Militär / Zivil</h3>
                        <Link class="link-btn" data-dontclose to="/galleries?military=true" on:click={window.location.assign("/galleries?military=true")}>Militär</Link>
                    {:else if currentSlideshowImage.military === 0}
                        <h3 data-dontclose>Militär / Zivil</h3>
                        <Link class="link-btn" data-dontclose to="/galleries?civil=true" on:click={window.location.assign("/galleries?civil=true")}>Zivil</Link>
                    {/if}
                </div>
                <div class="capture info">
                    {#if currentSlideshowImage.capturePlace.length > 0}
                        <h3 data-dontclose>Aufnahme Ort</h3>
                        {#each currentSlideshowImage.capturePlace as capturePlace}
                            <Link class="link-btn" data-dontclose to="/galleries?capturePlaces={capturePlace.id}" on:click={window.location.assign("/galleries?capturePlaces="+capturePlace.id)}>{capturePlace.title}</Link>
                        {/each}
                    {/if}
                    {#if currentSlideshowImage.captureDate}
                        <h3 data-dontclose>Aufnahme Datum</h3>
                        <Link class="link-btn" data-dontclose to="/galleries?captureDates={currentSlideshowImage.captureDate.split("-").join("")}" on:click={window.location.assign("/galleries?captureDates="+currentSlideshowImage.captureDate.split("-").join(""))}>{currentSlideshowImage.captureDate}</Link>
                    {/if}
                    {#if $getAirshowToImage.fetching}
                    {:else if $getAirshowToImage.error}
                    {:else}
                        {#if $getAirshowToImage.data.airshowToImage}
                            <h3 data-dontclose>Airshow</h3>
                            <Link class="link-btn" data-dontclose to="/airshows/{$getAirshowToImage.data.airshowToImage.slug}">{$getAirshowToImage.data.airshowToImage.title}</Link>
                        {/if}
                    {/if}

                </div>
                <div class="configuration info">
                    {#if currentSlideshowImage.specialPaint || currentSlideshowImage.doubleSeater || currentSlideshowImage.flares || currentSlideshowImage.afterburner || currentSlideshowImage.landingGear || currentSlideshowImage.breakParachute || currentSlideshowImage.waterPlane || currentSlideshowImage.static || currentSlideshowImage.museum || currentSlideshowImage.closeup}
                        <h3 data-dontclose>Konfiguration</h3>
                    {/if}
                    {#if currentSlideshowImage.specialPaint}
                        <!--Using a instead of Links to force a page reload...to load gallery with new data-->
                        <!--<Link class="link-btn" data-dontclose to="/galleries?specialPaint=true" on:click={window.location.assign("/galleries?specialPaint=true")}>Spezialbemalung</Link>-->
                        <a class="link-btn" data-dontclose href="/galleries?specialPaint=true">Spezialbemalung</a>
                    {/if}
                    {#if currentSlideshowImage.doubleSeater}
                        <a class="link-btn" data-dontclose href="/galleries?doubleSeater=true">Doppelsitzer</a>
                    {/if}
                    {#if currentSlideshowImage.flares}
                        <a class="link-btn" data-dontclose href="/galleries?flares=true">Flares</a>
                    {/if}
                    {#if currentSlideshowImage.afterburner}
                        <a class="link-btn" data-dontclose href="/galleries?afterburner=true">Nachbrenner</a>
                    {/if}
                    {#if currentSlideshowImage.landingGear}
                        <a class="link-btn" data-dontclose href="/galleries?landingGear=true">Fahrwerk</a>
                    {/if}
                    {#if currentSlideshowImage.breakParachute}
                        <a class="link-btn" data-dontclose href="/galleries?breakParachute=true">Bremsschirm</a>
                    {/if}
                    {#if currentSlideshowImage.waterPlane}
                        <a class="link-btn" data-dontclose href="/galleries?waterPlane=true">Wasserflugzeug</a>
                    {/if}
                    {#if currentSlideshowImage.static}
                        <a class="link-btn" data-dontclose href="/galleries?static=true">Statisch</a>
                    {/if}
                    {#if currentSlideshowImage.museum}
                        <a class="link-btn" data-dontclose href="/galleries?museum=true">Museum</a>
                    {/if}
                    {#if currentSlideshowImage.closeup}
                        <a class="link-btn" data-dontclose href="/galleries?closeup=true">Closeup</a>
                    {/if}
                </div>
            </div>
        </div>
    </div>
{/if}


<style lang="scss">
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .slideshow-nav {
      padding: var(--default-margin);
      position: absolute;
      cursor: pointer;
      color: white;
      &.close-slideshow {
        padding: 0;
        top: var(--default-margin);
        right: var(--default-margin);
        width: 50px;
        height: 50px;
      }
      &.show-image-data {
        padding: 0;
        bottom: var(--default-margin);
        left: var(--default-margin);
        border: 3px solid #bababa;
        border-radius: 50%;
        height: 1.5em;
        width: 1.5em;
        font-size: 2em;
        text-align: center;
        line-height: 1.4em;
        font-family: museo-slab, serif;
        font-weight: 700;
        color: #bababa;

        &:hover {
          color: white;
          border-color: white;
          &::after {
            background-color: white;
          }
        }
        &::after {
          opacity: 0;
          position: absolute;
          right: 18px;
          content: ' ';
          height: 45px;
          width: 3px;
          background-color: #bababa;
          transform: rotate(45deg);
        }
        &.active {
          &::after {
            opacity: 1;
          }
        }
      }
      &.next-image {
        right: 0;
        top: calc(50% - 50px);
      }
      &.prev-image {
        left: 0;
        top: calc(50% - 50px);
      }
    }
    .modal-container {
        width: fit-content;
        max-width: 90vw;
        max-height: 90vh;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        img{
          max-width: 100%;
          min-height: 30%;
          object-fit: contain;
          flex-shrink: 1;
          transition: all .5s ease;
        }
        .image-data {
          display: flex;
          flex-wrap: wrap;
          padding-top: var(--default-padding);
          max-height: 500px;
          overflow: hidden;
          opacity: 1;
          flex-shrink: 0;
          transition: max-height ease .3s, opacity ease .3s,  padding-top ease .3s;
          &.closed {
            padding-top: 0;
            max-height: 0;
            opacity: 0;
          }
          .info {
            margin-right: 4rem;
          }
          h3 {
            margin-top: .85rem;
            margin-bottom: .6rem;
            font-weight: 400;
            font-size: 1rem;
          }
        }
    }
    @media screen and (max-width: 750px) {
      .modal-container {
        .image-data {
          .info {
            width: 50%;
            flex-shrink: 0;
            margin-right: 0;
          }
        }
      }
    }
</style>